'use strict';

import ListEditablesView from 'commons/views/ListEditables';
import template from '../../templates/managers/Main.ejs';
import AddTpl from '../../templates/managers/Add.ejs';
import AccountView from './Account';
import User from 'newModels/user.js';
import loader from 'helpers/loader';
import Alerts from 'lib/alerts';
import modal from 'helpers/modal';

module.exports = ListEditablesView.extend({
    itemViews: [],
    modalView: null,

    events: function() {
        var parentEvents = _.isFunction(ListEditablesView.prototype.events) ?
            ListEditablesView.prototype.events() :
            ListEditablesView.prototype.events;

        return _.extend(_.clone(parentEvents), {
            'click .js-add': 'add',
            'input .js-email': 'onEmailChange'
        });
    },

    initialize: function(options) {
        this.options = _.defaults(options || {}, {
            template: template,
            Model: User,
            ModelView: AccountView,
            companies: null
        });
        this.options.templateExtra = {
            companies: this.options.companies,
            addModal: AddTpl({companies: this.options.companies})
        };

        return ListEditablesView.prototype.initialize.apply(
            this, [this.options]
        );
    },

    add: function(ev) {
        let stopLoader = loader.startFullScreen(ev.currentTarget);
        let email = this.$('.js-email').val();
        let name = this.$('.js-name').val();
        let companies = this.$('.js-companies').val() || [];

        User.inviteMppManager(name, email, companies).then(() => {
            stopLoader();
            this.$('#add-modal').modal('hide');
            return Alerts.show('success', {
                title: 'MPP Manager Invitation',
                text: 'Invitation successfully sent!'
            });
        }, err => {
            stopLoader();
            this.$('#add-modal').modal('hide');
            return Alerts.show('error', {
                title: 'MPP Invitation not sent',
                text: err
            });
        });
    },

    onEmailChange: function() {
        if (this.$('.js-email').val()) {
            this.$('.js-add').prop('disabled', false);
        } else {
            this.$('.js-add').prop('disabled', true);
        }
    },

    render: function() {
        let r = ListEditablesView.prototype.render.apply(this, arguments);
        this.$('.chosen-select').chosen({width: '100%'});
        return r;
    },

    renderModel: function(model) {
        let view = new this.options.ModelView({
            model: model,
            companies: this.options.companies
        });
        this.$('.js-model-views').append(view.$el);
        this.modelViews.push(view);
        return this;
    },

    save: function(ev) {
        var $button = this.$(ev.currentTarget);
        var stopLoader = loader.startFullScreen($button);

        this.trigger('save', this.collection);

        return Promise.all(this.collection.filter(model => model.dirty())
            .map(user => {
                return User.setMppManagerPermissions(
                    user.id,
                    user.get('managedCompanies')
                );
            }))
            .then(() => this.collection.fetch({reset: true}))
            .then(() => modal.showAlertSuccess('Your changes have been saved'))
            .finally(stopLoader);
    },
});



// WEBPACK FOOTER //
// ./app/mpp/views/managers/Main.js